import { Icon } from '@iconify/react'

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Icon
        icon="svg-spinners:3-dots-fade"
        className={`${sizes[size]} text-primary animate-spin`}
      />
    </div>
  )
}

export default LoadingSpinner
